export default "__VITE_ASSET__DMOlkbGv__"